import { CreatedInterfaces } from 'interfaces';
import { format } from 'date-fns';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'unnamed-lots';

function getPreviousMonth(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setMonth(date.getMonth() - 1);

  return previous;
}

function getTomorrowDate(date = new Date()) {
  const newDate = new Date(date.getTime());
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
}

const useGetAllUnnamedLots = (pageIndex: number, pageSize: number, startDate: string, endDate: string) => {
  let path = `v1/cards/unnamed?size=${pageSize}&page=${pageIndex === 0 ? 1 : pageIndex}`;
  const defaultStartDate = `${format(getPreviousMonth(), 'yyyy-MM-dd')}T00:00:00`;
  const defaultEndDate = `${format(getTomorrowDate(), 'yyyy-MM-dd')}T00:00:00`;

  path += `&start_date=${startDate || defaultStartDate}&end_date=${ endDate || defaultEndDate}`;

  const [{ data, error, loading }, execute] = useGetRequest<CreatedInterfaces<typeof resource>>({ path });

  return {
    unnamedLots: data?.data,
    pageInfo: {
      ...data?.meta,
      total: data?.meta?.total,
    },
    isLoading: loading,
    isError: error,
    execute
  };
};

export default useGetAllUnnamedLots;
